import React, { Component, Fragment } from "react";
import AppContext from "../../../contexts/AppContext";

export class Coupon extends Component {
	constructor(props) {
        super(props);
        this.state = { 
			item: this.props.item,           
            errors: this.props.errs,
            success: {},  
			loading: false,
			applied: false         
        };
    }
	onChange = field => {
        let temp = this.state.item;
        temp[field.target.name] = field.target.value;		
        let error = this.state.errors;
        error[field.target.name] = null;
        this.setState({ item: temp, errors: error });
	};
    validateCoupon = () => {
		let errs = {};
		let fields = this.state.item;
		fields['cpn_call'] = '1';
		if(fields.cpn_call == '1' && fields.coupon == '')
		{
			errs.coupon = "Please enter valid coupon";
			this.setState({errors: errs});
		}
		else
		{
			fields['cpn_call'] = '0';
			fields['coupon'] = this.state.item.coupon;
			errs['coupon'] = null; 			
			this.setState({item: fields, errors: errs, loading: true, applied : true });  
		}
		
	}

	removeCoupon = () => {
		let fields = this.state.item;
		let errs = {};
		fields['cpn_call'] = '0';
		fields['coupon'] = '';
		errs['coupon'] = ''; 
		this.setState({item: fields, errors: errs, loading: false, applied : false }); 
	}

	render() {
        return (
            <Fragment>
			    <div className="coupon-details">
			        <h3 className="mt-md-4 mt-3 mb-4">Coupon code</h3>
				    <div className="row">
				        <div className="col-sm-8 col-6">
							<div className="form-group mb-0">
								<label htmlFor="coupon" className="sr-only">Coupon Code</label>
								<input type="text" onChange={this.onChange} value={this.state.item.coupon || ''} className="form-control cpn px-4" name="coupon" id="coupon" ref="coupon" placeholder="Enter code here" autoComplete="off" disabled={this.state.applied}/>
								{this.state.errors.coupon ? (
									<div className="invalid-feedback">
										{this.state.errors.coupon}
									</div>
								) : null}
							</div>
				    	</div>
				    	<div className="col-sm-4 col-6">
							{
								this.state.applied === false ? 
							
				    	    	<button type="button" onClick={this.validateCoupon} className="d-block btn-primary border-0"><i className={this.state.loading ? `mr-2 fas fa-spinner fa-spin` : ``}></i> {this.state.loading ? `Processing...` : `Apply`}</button>
								: 	
								<button type="button" onClick={this.removeCoupon} className="d-block btn-danger border-0">Remove</button> 
							}
				    	</div>
				    </div>
				</div>	
			</Fragment>
		);
        
    }
}

Coupon.contextType = AppContext;
export default Coupon;



// WEBPACK FOOTER //
// ./src/components/general/include/Coupon.js